import { jsx } from "react/jsx-runtime";
import { Text } from "@zillow/constellation-10";
const BlockQuoteCitation = ({
  children
}) => /* @__PURE__ */ jsx(Text, { asChild: true, textStyle: "body-lg-bold", css: {
  fontStyle: "italic",
  textAlign: "center",
  display: "block",
  color: "inherit"
}, children: /* @__PURE__ */ jsx("cite", { children }) });
export {
  BlockQuoteCitation as default
};
